import { render } from "./QHLSAffliatedCentreList.vue?vue&type=template&id=1f334892"
import script from "./QHLSAffliatedCentreList.vue?vue&type=script&lang=js"
export * from "./QHLSAffliatedCentreList.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\shuha\\Documents\\Wisdom guide front\\wg-frontend-v1\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__